import { useEffect } from 'react';
import Logo from '../widget/Logo';
import FooterLight from '../widget/FooterLight';
import api from '../AxiosConfig';

const ContactFormPage = () => {
    const sendToBackend = async (formData, submissionId) => {
        try {
            const response = await api.post('/submit-contact-form', {
                firstname: formData.firstname || '',
                lastname: formData.lastname || '',
                email: formData.email || '',
                phone: formData.phone || '',
                company: formData.company || '',
                message: formData.message || '',
                hubspot_submission_id: submissionId
            });

            console.log(response.data);

            if (response.data.status_code === 200) {
                console.log('Successfully sent to backend');
            } else {
                console.error('Backend error:', response.data.message);
            }
        } catch (error) {
            console.error('Error sending to backend:', error);
        }
    };

    useEffect(() => {
        const script = document.createElement('script');
        script.src = 'https://js-na2.hsforms.net/forms/embed/247204826.js';
        script.defer = true;

        script.onload = () => {
            const checkHubSpot = setInterval(() => {
                if (window.hbspt) {
                    clearInterval(checkHubSpot);
                }
            }, 100);
        };

        document.body.appendChild(script);

        const handler = async (event) => {
            const form = window.HubSpotFormsV4?.getFormFromEvent?.(event);
            if (!form) return;
            const submissionId = form.getConversionId();
            const formData = await form.getFormFieldValues();
            const cleanedFormData = {};
            formData.forEach(({ name, value }) => {
                const cleanName = name.split('/').pop();
                cleanedFormData[cleanName] = value;
            });
            sendToBackend(cleanedFormData, submissionId || 'unknown');
        }

        window.addEventListener('hs-form-event:on-submission:success', handler);

        return () => {
            if (document.body.contains(script)) {
                document.body.removeChild(script);
            }

            window.removeEventListener('hs-form-event:on-submission:success', handler);
        };
    }, []);

    return (
        <div>
            <div className="page-container relative h-screen py-2 px-4">
                <div className='lg:px-12 lg:py-6 sm:p-4 md:p-8 flex flex-row justify-between'>
                    <Logo />
                </div>

                <div className="flex flex-col justify-center items-center gap-4 lg:px-32 sm:px-6 md:px-12">
                    <p className="text-3xl mt-auto" style={{ fontFamily: 'Red Hat Display' }}>Contact Us</p>
                    <p className="text-sm lg:w-1/2 sm:w-3/4 text-center">
                        We value your feedback and are here to assist you with any technical support or collaboration inquiries you may have.
                        Whether you have questions about using CONSOLE-D, need help troubleshooting an issue, or are interested in partnering with us, please feel free to reach out.
                    </p>

                    <div className="mt-8 lg:w-2/4">
                        <div
                            className="hs-form-frame"
                            data-region="na2"
                            data-form-id="1b3420cd-5c3f-4cc6-94e6-f468504367fd"
                            data-portal-id="247204826"
                        ></div>
                    </div>
                </div>
            </div>

            <div className="background-image">
                <FooterLight />
            </div>
        </div>
    );
};

export default ContactFormPage;
